import { ClientSide } from "~/@types";
import { IExpert } from "~/@types/generated/contentful";
import { CloseCta } from "../ctas";
import Bio from "./Bio";

type ExpertBioPageProps = {
  expert: ClientSide<IExpert>;
};

export default function ExpertBioPage({ expert }: ExpertBioPageProps) {
  return (
    <section className="relative min-h-screen w-screen bg-black pt-24 pb-20 text-white lg:pt-28">
      <div className="global-container col-span-full flex h-10 items-center justify-end">
        <CloseCta
          id="expert-bio-takeover-close"
          kind={"white"}
          to={`/experts/${expert.fields.slug}`}
        />
      </div>
      <Bio expert={expert} />
    </section>
  );
}
